export default {
  portal: {
    brand: 'Кабинет партнёра',
    hubLink: 'Партнёрский хаб',
    supplierLine: 'Кабинет поставщика Treejar',
    nav: {
      section: 'Рабочее пространство',
      home: 'Главная',
      products: 'Товары',
      upload: 'Загрузить прайс',
      demand: 'Спрос',
      reservations: 'Брони',
      orders: 'Заказы',
      finance: 'Финансы',
      warranty: 'Гарантия',
      contract: 'Договор и условия',
      team: 'Команда',
      more: 'Ещё',
      menu: 'Меню',
      signOut: 'Выйти',
    },
    shell: {
      partnerAccount: 'Кабинет партнёра',
      contractActive: 'Договор активен',
      notifications: 'Уведомления',
      openNav: 'Открыть навигацию',
      closeNav: 'Закрыть навигацию',
      userRole: 'Владелец',
      hub: 'Партнёрский хаб Treejar',
      manager: 'Менеджер Treejar',
      stockLoading: 'Загрузка кабинета',
    },
    notif: {
      title: 'Уведомления',
      unread: 'Новых: {{count}}',
      allRead: 'Все прочитаны',
      markAll: 'Прочитать все',
      filterAll: 'Все',
      filterOrders: 'Заказы',
      filterReservations: 'Брони',
      filterPayments: 'Оплаты',
      empty: 'Здесь пока пусто',
      emptyHint: 'Новые заказы, брони и оплаты появятся сразу.',
      showAll: 'Все заказы',
      settings: 'Настройки',
      orderTitle: 'Новый заказ {{po}} от Treejar',
      orderBody: '{{sku}} × {{qty}} · {{amount}} по партнёрской цене',
      orderBodyShort: '{{units}} ед. · {{amount}} по партнёрской цене',
      reservationTitle: 'Бронь {{no}} истекает {{when}}',
      reservationBody: '{{spec}} · {{units}} ед. ждут подтверждения',
      paymentTitle: 'Оплата получена · {{amount}}',
      paymentBody: 'Счёт {{invoice}} закрыт · заказ {{po}}',
      paymentDueTitle: 'Счёт {{invoice}} ждёт оплаты',
      paymentDueBody: '{{amount}} · срок {{date}}',
      inDays: 'через {{count}} дн.',
      inToday: 'сегодня',
      time: {
        justNow: 'Только что',
        minutes: '{{count}} мин назад',
        hours: '{{count}} ч назад',
        days: '{{count}} дн. назад',
        today: 'Сегодня',
      },
    },
    common: {
      save: 'Сохранить',
      saved: 'Сохранено',
      cancel: 'Отмена',
      confirm: 'Подтвердить',
      close: 'Закрыть',
      search: 'Поиск',
      all: 'Все',
      back: 'Назад',
      view: 'Открыть',
      open: 'Открыть',
      download: 'Скачать',
      upload: 'Загрузить',
      send: 'Отправить',
      reason: 'Причина',
      status: 'Статус',
      actions: 'Действия',
      total: 'Итого',
      quantity: 'Количество',
      date: 'Дата',
      amount: 'Сумма',
      due: 'Срок',
      note: 'Примечание',
      units: 'ед.',
      items: 'позиций',
      days: 'дн.',
      day: 'день',
      hours: 'ч',
      aed: 'AED',
      sku: 'Артикул',
      product: 'Товар',
      updated: 'Обновлено',
      from: 'из',
      to: 'до',
      none: 'Нет',
      add: 'Добавить',
      apply: 'Применить',
      reset: 'Сбросить',
      select: 'Выберите',
      optional: 'необязательно',
      dismiss: 'Закрыть',
      showing: 'Показано {{shown}} из {{total}}',
      ago: '{{count}} дн. назад',
      today: 'Сегодня',
    },
    status: {
      New: 'Новый',
      Confirmed: 'Подтверждён',
      AwaitingPayment: 'Ожидает оплаты',
      Paid: 'Оплачен',
      Shipped: 'Отгружен',
      ReadyForPickup: 'Готов к вывозу',
      PickedUp: 'Забран',
      Closed: 'Закрыт',
      WarrantyCase: 'Гарантийный случай',
      Active: 'Активна',
      Converted: 'Конвертирована в заказ',
      Expired: 'Истекла',
      Declined: 'Отклонена',
      UnderReview: 'На проверке',
      Published: 'Опубликован',
      Discontinued: 'Снят с продажи',
      Open: 'Открыт',
      ReplacementAgreed: 'Замена согласована',
      Invited: 'Приглашён',
    },
    login: {
      title: 'Кабинет поставщика для партнёров Treejar',
      subtitle: 'Держите остатки в актуальном состоянии, подтверждайте брони и следите за заказами и выплатами — в одном месте.',
      email: 'Электронная почта',
      emailPlaceholder: 'name@company.ae',
      password: 'Пароль',
      passwordPlaceholder: 'Ваш пароль',
      forgot: 'Забыли пароль',
      signIn: 'Войти',
      signingIn: 'Входим',
      remember: 'Не выходить на этом устройстве',
      hint: 'Используйте рабочую почту. Сотрудники склада могут войти с телефона.',
      errorEmpty: 'Введите почту и пароль.',
      errorInvalid: 'Почта или пароль не распознаны. Проверьте данные или сбросьте пароль.',
      resetTitle: 'Сброс пароля',
      resetBody: 'Для {{email}} подготовлена ссылка для сброса. В демо-режиме письмо не отправляется.',
      demoTitle: 'Демо-доступ',
      demoBody: 'partner@alkanz.ae · demo1234',
      demoFill: 'Подставить демо-доступ',
      backToLogin: 'Вернуться ко входу',
      feature1Title: 'Остатки всегда актуальны',
      feature1Text: 'Обновляйте количество прямо со склада в пару касаний.',
      feature2Title: 'Заказы без звонков',
      feature2Text: 'Подтверждайте заказы и назначайте дату готовности в кабинете.',
      feature3Title: 'Понятные выплаты',
      feature3Text: 'Сразу видно, сколько Treejar должен и когда ждать оплату.',
      secure: 'Защищённый доступ для партнёров · Treejar Trading LLC',
      switchHint: 'Выбранный язык запоминается на этом устройстве.',
    },
    home: {
      eyebrow: 'Суббота, 24 октября 2026',
      title: 'Доброе утро, Al Kanz',
      description: 'Ваш склад в Шардже подключён к Treejar. Два заказа ждут подтверждения сегодня.',
      attention: 'Требует внимания',
      cardOrdersTitle: '{{count}} новых заказа ждут подтверждения',
      cardOrdersBody: 'PO-2026-0145 и PO-2026-0146 · AED 44 300 по цене партнёра',
      cardOrdersCta: 'Открыть заказы',
      cardResTitle: '{{count}} брони истекают в течение 48 ч',
      cardResBody: 'R-0305, R-0309 и R-0311 · 115 единиц держим под спецификации Treejar',
      cardResCta: 'Открыть брони',
      cardStockTitle: 'Остатки не обновлялись 9 дней',
      cardStockBody: 'CH-229A, ST-180D и ещё 5 артикулов без обновления с 15 октября.',
      cardStockCta: 'Обновить остатки',
      kpiPublished: 'Товаров опубликовано',
      kpiPublishedHint: 'из 156 артикулов в каталоге',
      kpiStock: 'Единиц на складе',
      kpiStockHint: 'по 156 артикулам',
      kpiReserved: 'В активных бронях',
      kpiReservedHint: 'под спецификации Treejar',
      kpiOrders: 'Заказов за месяц',
      kpiOrdersHint: '6 заказов · AED 84 300',
      kpiAwaiting: 'Ожидает оплаты',
      kpiAwaitingHint: '2 счёта · срок 2 ноября',
      timelineTitle: 'Последние события',
      timelineSub: 'Заказы, оплаты и брони от Treejar',
      snapshotTitle: 'Сводка по аккаунту',
      snapshotSub: 'Договор, условия и ближайшая выплата',
      contractLabel: 'Договор',
      contractValue: 'Активен до 31 октября 2027',
      discountLabel: 'Скидка партнёра',
      discountValue: '22% от прайса',
      reservationPeriodLabel: 'Срок брони',
      reservationPeriodValue: '7 дней с момента подтверждения',
      nextPaymentLabel: 'Ближайшая выплата',
      nextPaymentValue: 'AED 25 575 · 6 ноября',
      managerLabel: 'Ваш менеджер Treejar',
      managerName: 'Layla Hassan',
      managerRole: 'Менеджер партнёров · Treejar Trading',
      viewAll: 'Все',
      note: 'Treejar не раскрывает конечных клиентов и цены перепродажи.',
      evOrder: 'Получен новый заказ {{po}} · {{units}} ед.',
      evPayment: 'Получена оплата · {{amount}} по {{invoice}}',
      evReservation: 'Бронь {{no}} истекла без подтверждения',
      evStock: 'Обновлены остатки по {{sku}}',
      evReady: 'Заказ {{po}} готов к вывозу',
      evWarranty: 'Открыта гарантийная заявка {{no}} по {{sku}}',
    },
    products: {
      title: 'Товары',
      subtitle: 'Остатки и поступления ведёте вы. Цены — партнёрские, согласованные с Treejar.',
      searchPlaceholder: 'Поиск по артикулу или названию',
      filterAll: 'Все',
      filterPublished: 'Опубликованы',
      filterReview: 'На проверке',
      filterDiscontinued: 'Сняты с продажи',
      colItem: 'Товар',
      colPrice: 'Цена партнёра',
      colStock: 'Остаток',
      colIncoming: 'Поступление',
      colEta: 'Срок',
      colStatus: 'Статус',
      colUpdated: 'Обновлено',
      hint: 'Меняйте остаток и количество в поступлении прямо в таблице — после сохранения Treejar сразу видит новые данные.',
      save: 'Сохранить изменения',
      savedToast: 'Остатки обновлены по {{count}} товарам',
      dirty: 'Несохранённых изменений: {{count}}',
      markDiscontinued: 'Снять с продажи',
      discontinuedToast: 'Снято с продажи: {{count}} товаров',
      selected: 'Выбрано: {{count}}',
      selectAll: 'Выбрать все товары',
      selectRow: 'Выбрать {{sku}}',
      stockNow: 'Остаток',
      incoming: 'Поступление',
      eta: 'Срок',
      empty: 'По этому фильтру товаров нет.',
      mobileNote: 'Крупное поле остатка для работы со склада',
      saveRow: 'Сохранить',
      rowSaved: '{{sku}} сохранён · остаток {{count}}',
      priceNote: 'Цена партнёра в AED без НДС',
      unitsInStock: '{{count}} ед.',
    },
    upload: {
      title: 'Загрузка прайс-листа',
      subtitle: 'Отправьте PDF, Excel или фото прайса с телефона. Мы распознаём таблицы, вы проверяете результат и подтверждаете новую версию.',
      drop: 'Перетащите прайс-лист сюда',
      dropSub: 'PDF, XLSX, CSV, JPG или PNG · до 40 МБ',
      browse: 'Выбрать файл',
      formats: 'Поддерживаемые форматы',
      fileChosen: '{{name}} · страниц: {{pages}}',
      stepUpload: 'Загрузка',
      stepReview: 'Проверка позиций',
      stepDiff: 'Сравнение',
      stepDone: 'Опубликовано',
      parsing: 'Читаем прайс-лист',
      parsingSub: 'Страница {{page}} из {{total}} — найдено позиций: {{count}}',
      parsingNote: 'Не закрывайте вкладку. До подтверждения ничего не публикуется.',
      reviewTitle: 'Проверьте распознанные позиции',
      reviewSub: 'Строки с низкой уверенностью выделены. Любую ячейку можно исправить.',
      confidenceHigh: 'Высокая',
      confidenceMedium: 'Проверить',
      confidenceLow: 'Низкая',
      lowHint: 'Перед публикацией проверьте строк: {{count}}.',
      colItem: 'Позиция',
      colSku: 'Артикул',
      colPrice: 'Цена партнёра',
      colStock: 'Остаток',
      colIncoming: 'Поступление',
      colEta: 'Срок',
      colConfidence: 'Уверенность',
      confirmItems: 'Перейти к сравнению',
      diffTitle: 'Изменения относительно версии {{version}}',
      diffSub: 'Показаны только отличия. При публикации предыдущая версия заменяется.',
      diffNew: 'Новые позиции',
      diffRemoved: 'Удалено',
      diffPrice: 'Изменения цен',
      diffStock: 'Изменения остатков',
      colChange: 'Изменение',
      colWas: 'Было',
      colNow: 'Стало',
      publish: 'Подтвердить и опубликовать',
      publishTitle: 'Опубликовать версию {{version}}?',
      publishSub: '{{count}} позиций из вашего прайса станут действующей версией. Treejar увидит новые цены и остатки в течение минуты.',
      publishConfirm: 'Опубликовать версию',
      publishedToast: 'Версия {{version}} опубликована · обновлено позиций: {{count}}',
      historyTitle: 'История загрузок',
      historySub: 'Каждая опубликованная версия хранится для аудита.',
      colVersion: 'Версия',
      colDate: 'Загружен',
      colItems: 'Позиции',
      colStatus: 'Статус',
      colChanges: 'Изменения',
      active: 'Действующая',
      superseded: 'Заменена',
      uploadNew: 'Загрузить другой файл',
      recognized: 'Распознано позиций: {{count}}',
      reset: 'Начать заново',
      fileName: 'Прайс октябрь 2026.xlsx',
      lowRowsLabel: 'строк требуют проверки',
    },
    demand: {
      title: 'Спрос',
      subtitle: 'Как часто ваши модели попадали в спецификации Treejar за 90 дней и что не удалось закрыть.',
      chartTitle: 'Запрошено единиц в спецификациях Treejar',
      chartSub: 'По моделям · последние 90 дней · запрошено, а не заказано',
      chartLegend: 'Запрошено единиц',
      last90: 'Последние 90 дней',
      colModel: 'Модель',
      colAdded: 'Добавлений в спецификации',
      colReserved: 'Забронировано, ед.',
      colOrdered: 'Заказано, ед.',
      colMissing: 'Запрошено, но нет',
      missingHint: 'нет на складе',
      hintTitle: 'Возможность для пополнения',
      hintBody: 'CH-229A: 3 запроса не удалось закрыть — остаток был нулевым. Поставка 40 единиц покрыла бы среднемесячный спрос.',
      hintCta: 'Обновить остатки',
      unitsLabel: 'ед.',
      footer: 'На основе {{count}} спецификаций Treejar. Имена клиентов и цены перепродажи не показываются.',
      times: '{{count}}×',
      requestedUnits: '{{count}} ед.',
    },
    reservations: {
      title: 'Брони',
      subtitle: 'Treejar держит ваш товар под спецификацию клиента 7 дней. Подтвердите бронь или отклоните с причиной.',
      filterAll: 'Все',
      confirmedToast: 'Бронь {{no}} подтверждена для Treejar',
      declinedToast: 'Бронь {{no}} отклонена · Treejar уведомлён',
      declineTitle: 'Отклонить бронь {{no}}',
      declineSub: 'Treejar увидит вашу причину. Остаток сразу вернётся в каталог.',
      declineReason: 'Причина',
      declinePlaceholder: 'Например: остаток зарезервирован под подтверждённый заказ',
      declineSubmit: 'Отклонить бронь',
      colNumber: 'Бронь',
      colSpec: 'Спецификация Treejar',
      colItems: 'Позиции',
      colQty: 'Единиц',
      colCreated: 'Создана',
      colExpires: 'Истекает',
      colStatus: 'Статус',
      colActions: 'Действия',
      confirmBtn: 'Подтвердить',
      declineBtn: 'Отклонить',
      empty: 'Броней с таким статусом нет.',
      note: 'До подтверждения бронь не блокирует остаток для других заказов Treejar.',
      expiresIn: 'через {{count}} дн.',
      expiresToday: 'сегодня',
      expiredOn: 'истекла {{date}}',
      units: '{{count}} ед.',
      itemLine: '{{sku}} × {{qty}}',
      specNote: 'Имя клиента не показывается — только номер спецификации.',
    },
    orders: {
      title: 'Заказы',
      subtitle: 'Заказы от Treejar по вашей партнёрской цене. Вывоз всегда организует Treejar с вашего склада.',
      colPo: 'Заказ',
      colDate: 'Дата',
      colItems: 'Позиции',
      colUnits: 'Единиц',
      colAmount: 'Сумма',
      colStatus: 'Статус',
      colAction: '',
      open: 'Открыть',
      empty: 'Заказов с таким статусом нет.',
      note: 'Суммы по партнёрской цене, без НДС. Цены клиентов не раскрываются.',
      kpiOpen: 'Открытых заказов',
      kpiConfirm: 'Ждут вашего подтверждения',
      kpiPickup: 'Готовы к вывозу',
      kpiMonth: 'За этот месяц',
      unitsCount: '{{count}} ед.',
    },
    order: {
      back: 'Заказы',
      notFound: 'Заказ не найден',
      meta: '{{partner}} · создан {{created}} · вывоз организует Treejar',
      confirm: 'Подтвердить заказ',
      confirmedToast: 'Заказ {{po}} подтверждён · Treejar может планировать вывоз',
      ready: 'Назначить дату готовности',
      readyToast: 'Дата готовности: {{date}}',
      replacement: 'Предложить замену',
      replacementTitle: 'Предложить замену',
      replacementSub: 'Выберите другую модель, которую можете поставить вместо отсутствующей.',
      replacementSelect: 'Модель для замены',
      replacementSubmit: 'Отправить предложение',
      replacementToast: 'Предложение замены отправлено менеджеру Treejar',
      markReady: 'Отметить готовым к вывозу',
      markReadyToast: 'Заказ {{po}} отмечен готовым к вывозу',
      linesTitle: 'Позиции заказа',
      linesSub: 'Количество и партнёрские цены на момент оформления заказа.',
      colSku: 'Артикул',
      colItem: 'Товар',
      colQty: 'Кол-во',
      colUnit: 'Цена партнёра',
      colAmount: 'Сумма',
      total: 'Итого по цене партнёра',
      units: '{{count}} ед.',
      docsTitle: 'Документы',
      docsSub: 'Счёт и накладная по этому заказу',
      invoice: 'Счёт',
      deliveryNote: 'Накладная',
      uploadInvoice: 'Загрузить документ',
      uploadNote: 'PDF или фото · до 10 МБ',
      uploaded: '{{name}} загружен',
      messagesTitle: 'Переписка с Treejar',
      messagesSub: 'Здесь отвечает ваш менеджер Treejar',
      messagePlaceholder: 'Напишите сообщение менеджеру Treejar',
      send: 'Отправить',
      pickupNote: 'Вывоз всегда выполняет Treejar с вашего склада. Обязанности по доставке у вас нет.',
      pickupTitle: 'Вывоз',
      stepper: {
        new: 'Новый',
        confirmed: 'Подтверждён',
        awaiting: 'Ожидает оплаты',
        paid: 'Оплачен',
        ready: 'Готов к вывозу',
        picked: 'Забран',
        closed: 'Закрыт',
      },
      nextStep: 'Следующий шаг',
      readyDateLabel: 'Дата готовности',
      readyDateSubmit: 'Сохранить дату',
      partner: 'Партнёр',
      created: 'Создан',
      docEmpty: 'Документы пока не загружены.',
      threadEmpty: 'Сообщений пока нет.',
      requested: 'Запрошено',
    },
    finance: {
      title: 'Финансы',
      subtitle: 'Счета, статус оплат и ближайшие суммы к получению.',
      paidMonth: 'Оплачено за месяц',
      paidMonthHint: '2 счёта закрыты',
      awaiting: 'Ожидает оплаты',
      awaitingHint: '2 счёта · срок 2–6 ноября',
      next: 'Ближайшая выплата',
      nextHint: 'после оплаты клиентом',
      bannerTitle: 'Как Treejar платит партнёрам',
      bannerBody: 'Treejar платит партнёрам в ритме оплаты клиента: предоплата от клиента → предоплата вам, остаток — после оплаты клиентом.',
      invoicesTitle: 'Счета',
      invoicesSub: 'Ваши счета Treejar и их текущий статус',
      colInvoice: 'Счёт',
      colPo: 'Заказ',
      colAmount: 'Сумма',
      colStatus: 'Статус',
      colDue: 'Срок оплаты',
      uploadInvoice: 'Загрузить счёт',
      downloadStatement: 'Скачать выписку',
      statementToast: 'Выписка за октябрь 2026 подготовлена',
      invoiceToast: 'Счёт отправлен в бухгалтерию Treejar',
      invoiceTitle: 'Загрузить счёт',
      invoiceSub: 'Приложите счёт по поставленному заказу. Бухгалтерия Treejar получит уведомление.',
      invoiceAmount: 'Сумма, AED',
      invoicePo: 'Заказ',
      submit: 'Отправить счёт',
      empty: 'Счетов пока нет.',
      note: 'Все суммы в AED. Партнёрские цены без НДС.',
      dueLabel: 'Срок {{date}}',
    },
    warranty: {
      title: 'Гарантия',
      subtitle: 'Заявки Treejar по вашим товарам. Ответьте, согласуйте замену или закройте случай.',
      colClaim: 'Заявка',
      colPo: 'Заказ',
      colItem: 'Товар',
      colStatus: 'Статус',
      colUpdated: 'Обновлено',
      empty: 'Гарантийных заявок нет.',
      back: 'Гарантия',
      notFound: 'Заявка не найдена',
      description: 'Что произошло',
      photos: 'Фото от Treejar',
      reply: 'Ответить Treejar',
      replyPlaceholder: 'Опишите результат проверки, план замены или дату поставки',
      send: 'Отправить ответ',
      agree: 'Согласовать замену',
      agreedToast: 'Замена согласована · логистика Treejar заберёт неисправный товар',
      replyToast: 'Ответ отправлен менеджеру Treejar',
      claimMeta: '{{po}} · {{sku}} · заявлено {{date}}',
      reported: 'Заявлено',
      resolution: 'Решение',
      warrantyNote: 'Замена поставляется бесплатно. Неисправный товар Treejar забирает одновременно с заменой.',
      statusOpen: 'Открыта',
      statusAgreed: 'Замена согласована',
      statusClosed: 'Закрыта',
      open: 'Открыть заявку',
      claimCount: 'Открытых заявок: {{count}}',
      resolveTitle: 'Решение',
      resolveBody: 'Замена согласована по {{sku}}. Вывоз запланирован вместе со следующим забором Treejar.',
    },
    contract: {
      title: 'Договор и условия',
      subtitle: 'Ваш договор на перепродажу с Treejar и коммерческие условия, которые действуют по всем заказам.',
      preview: 'Предпросмотр договора',
      download: 'Скачать договор',
      downloaded: 'PDF договора скачан',
      status: 'Статус',
      statusActive: 'Активен · подписан обеими сторонами',
      signedOn: 'Подписан',
      validUntil: 'Действует до',
      termsTitle: 'Коммерческие условия',
      termsSub: 'Согласованы с Treejar и применяются ко всем заказам и броням',
      discount: 'Скидка партнёра',
      discountValue: '22% от вашего прайса',
      specialTitle: 'Спецпредложения',
      specialValue: 'CH-229A и HY-128C · без скидки',
      minResaleTitle: 'Минимальная цена перепродажи',
      minResaleValue: 'Treejar не может продавать ниже 1,15× вашей партнёрской цены',
      reservationTitle: 'Срок брони',
      reservationValue: '7 дней с момента подтверждения',
      paymentTitle: 'Оплата',
      paymentValue: 'В ритме оплаты клиента · предоплата, затем остаток',
      pickupTitle: 'Вывоз',
      pickupValue: 'Всегда силами Treejar с вашего склада',
      note: 'Чтобы изменить условия, свяжитесь с менеджером Treejar.',
      managerTitle: 'Ваш менеджер Treejar',
      managerSub: 'Договор, условия и коммерческие вопросы',
      managerName: 'Layla Hassan',
      managerRole: 'Менеджер партнёров · Treejar Trading LLC',
      managerPhone: '+971 50 214 8890',
      managerEmail: 'layla@treejartrading.ae',
      contact: 'Написать в WhatsApp',
      contactToast: 'Чат WhatsApp с Layla Hassan подготовлен',
      docsTitle: 'Документы',
      docContract: 'Договор на перепродажу',
      docTerms: 'Приложение с условиями',
      docPriceList: 'Прайс-лист v12',
      docVersion: 'PDF · версия 3 · 1,4 МБ',
      pageOf: 'Страница {{page}} из {{total}}',
      contractTitle: 'ДОГОВОР НА ПЕРЕПРОДАЖУ',
      contractParty: 'Treejar Trading LLC — Al Quoz Industrial 4, Дубай, ОАЭ',
      contractCounterparty: 'Al Kanz Office Furniture Tr — Склад №6, Industrial Area 18, Шарджа, ОАЭ',
      signature: 'Подписано за Al Kanz Office Furniture Tr',
      signatureName: 'Aisha Al Kanz · Владелец',
    },
    team: {
      title: 'Команда',
      subtitle: 'Сотрудники вашей компании с доступом в кабинет и их права.',
      invite: 'Пригласить пользователя',
      colName: 'Имя',
      colEmail: 'Почта',
      colRole: 'Роль',
      colLast: 'Последний вход',
      colStatus: 'Статус',
      roleOwner: 'Владелец',
      roleWarehouse: 'Склад',
      roleSales: 'Продажи',
      roleAccounting: 'Бухгалтерия',
      statusActive: 'Активен',
      statusInvited: 'Приглашён',
      inviteTitle: 'Пригласить сотрудника',
      inviteSub: 'Он получит письмо со ссылкой для установки пароля.',
      inviteName: 'Имя и фамилия',
      inviteEmail: 'Рабочая почта',
      inviteRole: 'Роль',
      inviteSubmit: 'Отправить приглашение',
      invitedToast: 'Приглашение отправлено на {{email}}',
      notifTitle: 'Уведомления',
      notifSub: 'Выберите, как сообщать о каждом событии',
      notifEvent: 'Событие',
      notifEmail: 'Почта',
      notifWhatsapp: 'WhatsApp',
      notifSaved: 'Настройки уведомлений сохранены',
      savedToast: 'Настройки команды обновлены',
      evOrders: 'Новый заказ или бронь',
      evPayments: 'Получена оплата',
      evReservations: 'Бронь истекает',
      evStock: 'Напоминание обновить остатки',
      evWarranty: 'Открыта гарантийная заявка',
      evPriceList: 'Прайс-лист опубликован',
      seats: 'Использовано {{used}} из {{total}} мест',
      lastNever: 'Ещё не входил',
      remove: 'Удалить',
      removedToast: 'Доступ для {{name}} удалён',
      note: 'Владелец всегда видит цены и выплаты. Склад может только обновлять остатки.',
    },
  },
};